module.exports = __webpack_public_path__ + "static/media/gears.d2b90adc.png";